import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../../constants';
import { formatProbability } from '../../../utils/common';

const MarketMarginsRow = (props) => {
  const marketName = props.allMarkets?.find((market) => market?.id
    === props.marketMarginsDetails?.marketId)?.name;
  return (
    <tr className={`table-style__row 
          ${props.marketMarginsDetails?.hasChanges && props.overallTableHasChanges ? 'table-style__row--change' : ''}`}
    >
      <td>{props.defaultMarketMargins ? props.marketId : marketName}</td>
      <td>
        <div className="margins">
          {props.marketMarginsDetails?.levels.map((level, idx) => {
            // levelTo is setted automatically according to odds value interval :
            // if it is the last interval(level) :  it will be setted into 1000 otherwise
            // the value will be [next interval value]-0.01
            const levelTo = idx === props.marketMarginsDetails?.levels?.length - 1
              ? 1000
              : (props.marketMarginsDetails?.levels[idx + 1]?.fromOdds - 0.01).toFixed(2);
            const levelKey = `${props.marketMarginsDetails?.marketId}-margins-${idx}`;
            return (
              <div className="margins__item" key={levelKey}>
                <div className="margins__item-txt">
                  From
                  {' '}
                  <span>{level?.fromOdds?.toFixed(2)}</span>
                  {' '}
                  To
                  {' '}
                  <span>{levelTo}</span>
                  {' '}
                  =
                  {' '}
                  <span>{level?.margin?.toFixed(2)}</span>
                </div>
              </div>
            );
          })}
        </div>
      </td>
      {props.marketMarginsDetails?.marginOverride
        && (
          <>
            <td>
              <span className={`${props.marketMarginsDetails?.marginOverride?.enabled ? 'icon-check' : 'icon-uncheck'}`} />
            </td>

            <td>
              <span>
                {props.marketMarginsDetails?.marginOverride?.enabled
                  ? `${(formatProbability(props.marketMarginsDetails?.marginOverride?.probabilityThreshold) || 0).toFixed(0)} %`
                  : '-'}
              </span>
            </td>
          </>
        )}
      <td>
        {props.hasPermissionToUpdate && (
          <div className="d-flex justify-content-center">
            <div className="action action--visible">
              <div className="action-wrap">
                <div
                  className="action__btn action__btn--edit"
                  onClick={props.editMarketMargin
                    .bind(this, props.marketMarginsDetails?.marketId)}
                >
                  <SVGComponent
                    src={`${SVG_ICONS.utility}#edit-w`}
                  />
                </div>
                {!props.defaultMarketMargins && (
                  <div
                    className="action__btn action__btn--cancel"
                    onClick={props.removeMarketMargin
                      .bind(this, props.marketMarginsDetails?.marketId)}
                  >
                    <SVGComponent
                      src={`${SVG_ICONS.utility}#close-w`}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
};

export default MarketMarginsRow;
